import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@anytag/shared-utils';
import { HelpIcon } from '../Icon';
import { TextCutter } from '../TextCutter';

export interface LabelProps {
  title: ReactNode;
  help?: ReactNode;
  className?: string;
  required?: boolean;
  optional?: boolean;
  /**
   * @description: iconMargin: 'ml-auto' | or other TW class
   */
  iconMargin?: string;
  labelLoader?: ReactNode;
}

export const Label = ({
  help,
  title,
  required,
  optional,
  className,
  labelLoader,
  iconMargin = 'ml-auto'
}: LabelProps) => {
  const { t } = useTranslation();

  return (
    <label
      className={cn(
        'mb-2 box-border flex w-full items-center text-sm leading-[normal] font-normal text-zinc-500 font-stretch-normal',
        className
      )}
    >
      {typeof title === 'string' ? <TextCutter text={title} lines={1} /> : title}
      {required && <span className="text-error">&nbsp;*</span>}
      {labelLoader}
      {optional ? <span className="ml-1 text-tertiary">({t('Optional')})</span> : null}
      {help && <HelpIcon help={help} place="top-end" className={iconMargin} />}
    </label>
  );
};
